import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { localization } from "@app2/shared/localization/localization";
import { DropdownOption } from "@app2/shared/predicate-dropdown-menu.component";
import {
    DRAFT_SLUG,
    INCIDENT_SLUG,
    incidentStateOptions,
    SlugName,
    StateOptions,
    taskStateOptions,
    TicketState,
} from "@app2/ticket/ticket-constants";

@Component({
    selector: "ticket-state-dropdown",
    template: `
        <!-- leaving incidents as single select while tasks get multi select -->
        <predicate-dropdown-menu *ngIf="slugName === 'incident' || slugName === 'draft'"
                                 label="STATE"
                                 [options]="stateOptions"
                                 [initialValue]="selectedStates[0]"
                                 (onSelect)="emitOnlyIfValueChanged($event)">
        </predicate-dropdown-menu>
        <savable-multiselect-dropdown *ngIf="slugName === 'task'"
                                      labelKey="STATE"
                                      [options]="stateOptions"
                                      [selection]="stateSelection"
                                      (selectionChange)="statesChanged.emit($event)">
        </savable-multiselect-dropdown>
    `,
})
export class TicketStateDropdownComponent implements OnChanges {
    @Input() slugName: SlugName;
    @Input() selectedStates: TicketState[];
    @Output() statesChanged = new EventEmitter<Partial<Record<TicketState, boolean>>>();

    stateOptions: StateOptions;
    stateSelection: Partial<Record<TicketState, boolean>> = {};

    ngOnChanges(changes: SimpleChanges) {
        if (changes.slugName) {
            this.stateOptions = ([INCIDENT_SLUG, DRAFT_SLUG].includes(this.slugName) ? incidentStateOptions : taskStateOptions)
                .map(option => ({ ...option, key: localization.getString(option.key) }));
        }

        if (changes.selectedStates) {
            this.stateSelection = Object.fromEntries(this.selectedStates.map(state => [state, true]));
        }
    }

    emitOnlyIfValueChanged(selectedOption: DropdownOption<never, TicketState>) {
        if (selectedOption.value !== this.selectedStates[0]) {
            this.statesChanged.emit(this.singleDropdownValueToMultiple(selectedOption));
        }
    }

    singleDropdownValueToMultiple(selectedOption: DropdownOption<never, TicketState>): Partial<Record<TicketState, boolean>> {
        return { [selectedOption.value]: true };
    }
}